import { createApp } from 'vue';
import VueClickAway from 'vue3-click-away';
import DKToast from 'vue-dk-toast';
import { createI18n } from 'vue-i18n';
import { createGtm } from '@gtm-support/vue-gtm/dist';
import VueGtag from 'vue-gtag-next';

import App from './App.vue';
import router from './router';
import store from './store';
import { defaultLocale, locale, messages } from './i18n';

import 'mq-ui-kit/css/mq-ui-kit.scss';
import './assets/styles/main.scss';

const i18n = createI18n({
  locale,
  fallbackLocale: defaultLocale,
  messages,
});

createApp(App)
  .use(store)
  .use(router)
  .use(i18n)
  .use(VueClickAway)
  .use(DKToast)
  .use(VueGtag, {
    property: {
      id: 'UA-181768934-2',
    },
  })
  .use(
    createGtm({
      id: 'GTM-WCKDLLJ',
      defer: false,
      compatibility: false,
      nonce: '2726c7f26c',
      enabled: true,
      debug: true,
      loadScript: true,
      vueRouter: router,
      ignoredViews: ['homepage'],
      trackOnNextTick: false,
    }),
  )
  .mount('#app');
